export default "assets/images/558bc7e8b9b6c5f41a7141cddb8cdb5e.png";